<template>
    <div
        class="fixed  w-full animate-slideInFromRight bg-brand-50 p-4 text-center"
        :style="{ zIndex: layer2 }"
    >
        <div class="flex justify-center">
            <div class="shrink-0">
                <ExclamationTriangleIcon
                    class="size-5 text-brand-400"
                    aria-hidden="true"
                />
            </div>
            <div class="ml-3">
                <p class="text-sm text-brand-700">
                    You are offline.
                    {{ ' ' }}
                    Please check your connection.
                </p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ExclamationTriangleIcon } from '@heroicons/vue/20/solid';
const { layer2 } = useRuntimeConfig().public.appLayout.zIndex;
</script>
